import { z } from 'zod'
import { ClassroomDegree } from '@/core/domain/resources/enums/ClassroomDegree.ts'
import { QuizType } from '@/core/domain/resources/enums/QuizType.ts'

/**
 * Representation of a filter for school classrooms
 */
export const ExportFilterSchoolClassroomSchema = z.object({
  id: z.number(),
  name: z.string(),
  degree: z.nativeEnum(ClassroomDegree.Values)
})

/**
 * Representation of a filter for schools
 */
export const ExportFilterSchoolSchema = z.object({
  id: z.number(),
  name: z.string(),
  city: z.string(),
  zipCode: z.string(),
  classrooms: z.array(ExportFilterSchoolClassroomSchema)
})

/**
 * Representation of a list of filters for schools
 */
export const ExportFilterSchoolListSchema = z.array(ExportFilterSchoolSchema)

/**
 * Representation of a filter for exporting data
 */
export const ExportFilterInputSchema = z.object({
  year: z.number().int().nonnegative(),
  schools: z.array(z.number().int().positive()).default([]),
  degrees: z.array(z.nativeEnum(ClassroomDegree.Values)).default([]),
  classrooms: z.array(z.number().int().positive()).default([]),
  diagnosticType: z.nativeEnum(QuizType.Values).nullish()
}).refine(o => o.diagnosticType === null
  || o.diagnosticType === QuizType.Values.DIAG_START
  || o.diagnosticType === QuizType.Values.DIAG_END,
  { message : "diagnosticType must be one of: 'DIAG_START', 'DIAG_END', or 'null'" }
)

export const ExportResultSchema = z.object({
  filename: z.string(),
  blob: z.instanceof(Blob)
})

export type ExportFilterSchoolEntity = z.infer<typeof ExportFilterSchoolSchema>
export type ExportFilterSchoolClassroomEntity = z.infer<typeof ExportFilterSchoolClassroomSchema>
export type ExportFilterInputEntity = z.infer<typeof ExportFilterInputSchema>
export type ExportResultEntity = z.infer<typeof ExportResultSchema>